// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"simple__wrapper-29_lv","filter":"simple__filter-3pfR5 blocks__base-3OSxK"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/filterable-tree/filter/simple/filter.css
// module id = 819
// module chunks = 0